import { Popover } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/core/styles';
import { toobarTheme } from './ToolbarUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Styles from './FilterPopover.scss';

const ActionPopover = ({ id, open, anchorEl, handleClose, item, dataCy }) => {
    const onListItemClick = (item) => {
        item.function();
        handleClose();
    };

    return (
        <ThemeProvider theme={toobarTheme}>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left'
                }}
            >
                <div className={Styles.defaultFilterContainer} data-cy={`${dataCy}-actions`}>
                    {item.map((i, index) =>
                        <div className={Styles.actionOptionItem} key={i.key + index.toString()} onClick={() => onListItemClick(i)}>
                            <span>
                                <FontAwesomeIcon icon={i.icon} className={Styles.actionIcon} />
                                {i.label}
                            </span>
                        </div>
                    )}
                </div>
            </Popover >
        </ThemeProvider>
    );
};

export default ActionPopover;